import React from 'react'
import { P } from '@farewill/ui'
import { GTR } from '@farewill/ui/tokens'
import { PRODUCTS } from 'lib/products/constants'
import { RoleSection, RoleTemplate, RoleTitle, RoleUl } from '../RoleTemplate'

const SeniorProbateSolicitor = (): React.JSX.Element => (
  <RoleTemplate
    roleName="Senior Probate Solicitor"
    roleUrl="https://dignity.kallidusrecruit.com/vacancyinformation.aspx?vguid=5d843398-9875-4a4d-942c-f66acb022a7a"
    location="Maidenhead (Hybrid – 3 days on-site, 2 days from home)"
    salary="Up to £65,000 per annum (depending on experience)"
    contractType="Full-time, Permanent"
    closingDate="1st August 2025"
    product={PRODUCTS.PROBATE}
    content={
      <>
        <RoleSection margin={[GTR.M, 0]}>
          <RoleTitle>The Role</RoleTitle>
          <P>
            Are you ready to take the next step in your legal career with one of
            Europe&apos;s most progressive consumer legal tech companies?
            We&apos;re seeking a talented Solicitor to join our high-performing,
            newly established legal team. In this role, you&apos;ll work closely
            with our Head of Legal and collaborate cross-functionally with our
            sales and product teams to help deliver best-in-class Wills and
            Probate services to our clients.
          </P>
        </RoleSection>
        <RoleSection margin={[GTR.M, 0]}>
          <RoleTitle>You Will</RoleTitle>
          <RoleUl>
            <li>
              Lead and manage complex and high-value probate cases from
              instruction to estate distribution
            </li>
            <li>
              Provide expert legal advice on both taxable and non-taxable
              estates
            </li>
            <li>
              Draft and review probate documents, including, Inheritance tax
              forms, and estate accounts
            </li>
            <li>
              Ensure compliance with all relevant legal and regulatory
              frameworks
            </li>
            <li>
              Collaborate with cross-functional teams (product, operations,
              client services) to enhance service delivery
            </li>
            <li>
              Contribute to the development of innovative, technology-enabled
              probate processes
            </li>
            <li>
              Balance legal risk and business objectives with a pragmatic,
              commercial mindset
            </li>
            <li>
              Mentor junior legal staff and contribute to legal
              knowledge-sharing within the team
            </li>
          </RoleUl>
        </RoleSection>
        <RoleSection margin={[GTR.M, 0]}>
          <RoleTitle>What We&apos;re Looking For</RoleTitle>
          <RoleUl>
            <li>
              5+ years&apos; post-qualification experience as a probate
              solicitor
            </li>
            <li>Demonstrable expertise managing complex, high-value estates</li>
            <li>
              Strong understanding of probate law, estate administration, tax,
              and compliance
            </li>
            <li>
              Confident in a range of legal drafting, particularly IHT forms and
              estate accounts
            </li>
            <li>
              Commercially aware, with a solutions-focused, pragmatic approach
            </li>
            <li>Excellent communication and stakeholder management skills</li>
            <li>
              Comfortable working in a technology-driven, fast-paced environment
            </li>
            <li>
              Collaborative mindset – able to work well with legal and non-legal
              colleagues alike
            </li>
          </RoleUl>
        </RoleSection>
        <RoleSection margin={[GTR.M, 0]}>
          <RoleTitle>What We Offer</RoleTitle>
          <RoleUl>
            <li>Annual salary of up to £65,000 depending on experience</li>
            <li>25 Days Holiday + Bank Holidays</li>
            <li>BUPA Healthcare (Self)</li>
            <li>Company Bonus Incentive</li>
            <li>X2 Life Assurance</li>
            <li>Pension Scheme</li>
            <li>Hybrid flexible working (3 days in our Maidenhead office)</li>
            <li>Genuine career progression and mentorship opportunities</li>
            <li>
              A chance to make a meaningful contribution to people&apos;s lives
              and deaths
            </li>
          </RoleUl>
        </RoleSection>
      </>
    }
  />
)

export default SeniorProbateSolicitor
